<template>
  <v-snackbar v-model="snackbar" :color="snackColor" :timeout="timeout" top>
    <div>
      <div v-for="(txt, idx) in lines" :key="idx">
        {{ txt }}
      </div>
    </div>
    <v-btn dark flat @click="snackbar = false">
      <nt-icon>close</nt-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    props: ['text', 'color', 'isVisible'],
    computed: {
      lines() {
        return this.text ? this.text.split('\n') : [];
      },
      snackbar: {
        get() {
          return this.isVisible;
        },
        set(val) {
          if (!val) {
            this.$emit('closed');
          }
        }
      },
      timeout() {
        return (this.color === 'error') ? 0 : 5000;
      },
      snackColor() {
        return this.color || 'info';
      }
    }
  }
</script>
